import { IconButton } from 'anf-core-react';
import PropTypes from 'prop-types';
import React from 'react';

export default function SliderControls({
  isScrollAllowed,
  showControls,
  sliderControlOffset = undefined,
  previousLabel = undefined,
  nextLabel = undefined,
  onSlideLeft,
  onSlideRight,
  isInfinite,
  state,
}) {
  let showRightControl = true;
  let showLeftControl = true;

  if (!isScrollAllowed) return null;

  const setSliderControlPosition = sliderControlOffset ? { top: `${sliderControlOffset}px` } : {};
  const controlVisibility = showControls ? {} : { visibility: 'hidden' };

  if (state.index === 0 && !isInfinite) showLeftControl = false;
  if (state.isLastSlide) showRightControl = false;

  return (
    <>
      <div
        aria-hidden="true"
        className={`control-container left ${showLeftControl ? '' : 'hidden'}`}
        style={{ ...setSliderControlPosition, ...controlVisibility }}
      >
        <IconButton
          tabIndex="-1"
          icon="left-thin"
          labelText={previousLabel}
          onClick={() => onSlideLeft()}
          theme="inverse"
          variant="square"
        />
      </div>
      <div
        aria-hidden="true"
        className={`control-container right ${showRightControl ? '' : 'hidden'}`}
        style={{ ...setSliderControlPosition, ...controlVisibility }}
      >
        <IconButton
          tabIndex="-1"
          icon="right-thin"
          labelText={nextLabel}
          onClick={() => onSlideRight()}
          theme="inverse"
          variant="square"
          disabled={!isInfinite && state.index >= state.slides.length - 1}
        />
      </div>
    </>
  );
}

SliderControls.propTypes = {
  isScrollAllowed: PropTypes.bool.isRequired,
  showControls: PropTypes.bool.isRequired,
  sliderControlOffset: PropTypes.number,
  previousLabel: PropTypes.string,
  nextLabel: PropTypes.string,
  onSlideLeft: PropTypes.func.isRequired,
  onSlideRight: PropTypes.func.isRequired,
  isInfinite: PropTypes.bool.isRequired,
  state: PropTypes.shape({
    index: PropTypes.number.isRequired,
    slides: PropTypes.arrayOf(PropTypes.node).isRequired,
  }).isRequired,
};
